import $ from './includes/jquery.min';
import './includes/bootstrap.min';
import './includes/clipboard.min';
import './includes/countdown';
import './includes/datetimepicker';
import './includes/easy.responsive.tabs';
import './includes/isotope.pkgd.min';
import './includes/jquery.counterup.min';
import './includes/jquery.magnific-popup.min';

import './includes/jquery.mousewheel.min';
import './includes/jquery.stellar.min';
import './includes/lightgallery-all';
import './includes/nav-menu';
import './includes/owl.carousel';
import './includes/popper.min';
import './includes/prism';
import './includes/waypoints.min';
import './includes/main';


console.log("frontend");

window.$ = window.jQuery = jQuery= $;
